export default __webpack_public_path__ + "static/media/duracell_1225x150px.b3b7452a.png";